function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "attachment-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M15.8645 8.1752L9.10284 14.9369C7.56515 16.4746 5.07206 16.4746 3.53437 14.9369C1.99668 13.3992 1.99668 10.9061 3.53437 9.36844L10.2961 2.60674C11.3212 1.58161 12.9833 1.58161 14.0084 2.60674C15.0335 3.63186 15.0335 5.29392 14.0084 6.31905L7.51185 12.8156C6.99928 13.3282 6.16825 13.3282 5.65569 12.8156C5.14313 12.303 5.14313 11.472 5.65569 10.9594L11.3567 5.25839",
    stroke: "#8B8696",
    style: {
      stroke: "#8B8696",
      stroke: "color(display-p3 0.5451 0.5255 0.5882)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.68501fb2e5c5c6b8ab0c3301d5bf93cf.svg";
export { ForwardRef as ReactComponent };